import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router'
import { useFetchAuthorisation, authorisationConverter, useFetchUserData } from '../../utils/AppFunctions'
import config from '../../app-config'
import { fetch_missions_by_id, create_new_mission, update_mission, delete_mission, fetch_mission_members_by_id, add_mission_member, remove_mission_member, update_mission_member } from '../../api/missionsAPI'
import { fetch_all_countries } from '../../api/countryAPI'
import { fetch_all_users_admin } from '../../api/usersAPI'
import 'react-toastify/dist/ReactToastify.css';
import AdminLayout from '../../layouts/AdminLayout'
import Switch from 'react-switch'
import Select from 'react-select'
import JoditEditor from 'jodit-react';
import notify from '../../utils/IANotification';
import ModalLayout from '../../layouts/ModalLayout';
import { MdAdd, MdDelete, MdPersonAdd } from 'react-icons/md';
import { FaPrayingHands } from 'react-icons/fa';
import { fetch_all_accounts } from '../../api/accountsAPI'

export default function MissionsFormPage() {
  const navigate = useNavigate()
  const { isAuthorised, userRole } = useFetchAuthorisation("user")
  let user_data = useFetchUserData()

  const editor = useRef(null);
  const placeholder = "Start typing...";

  const liveConfig = {
    height: 500,
    placeholder,
    // set custom buttons
    buttons: [
      'bold',
      'italic',
      'underline',
      'strikethrough',
      'superscript',
      'subscript',
      'ul',
      'ol',
      'outdent',
      'indent',
      'font',
      'fontsize',
      'brush',
      'paragraph',
      'table',
      'link',
      'undo',
      'redo',
      'eraser',
      'copyformat',
    ],
    askBeforePasteHTML: false,
    hotkeys: {
      redo: 'ctrl+z',
      undo: 'ctrl+y,ctrl+shift+z',
      indent: 'ctrl+]',
      outdent: 'ctrl+[',
      bold: 'ctrl+b',
      italic: 'ctrl+i',
      removeFormat: 'ctrl+shift+m',
      insertOrderedList: 'ctrl+shift+7',
      insertUnorderedList: 'ctrl+shift+8',
      openSearchDialog: 'ctrl+f',
      openReplaceDialog: 'ctrl+r',
    },
  };

  let mission_id = new URLSearchParams(window.location.search).get("mission_id")
  const [missionData, setMissionsData] = useState({
    country_id: "",
    title: "",
    description: "",
    start_datetime: "",
    end_datetime: "",
  })
  const [prayerListData, setPrayerListData] = useState({
    type: "mission",
    title: "",
    description: "",
    is_archived: "0",
  })
  const [prayers, setPrayers] = useState([]) // {content: "", is_archived: "0", is_answered: "0", user_id: "", prayer_list_id: "", can_repeat: "0", prayers_count: [], testimony: ""}

  const [missionaryData, setMissionaryData] = useState([])
  const [countryData, setCountryData] = useState([])
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(false)
  const [showMemberModal, setShowMemberModal] = useState(false)
  const [tempUserData, setTempUserData] = useState({})
  const [accountData, setAccountData] = useState([])
  let prayer_list_id = prayerListData?.id

  const fetchMissionById = async () => {
    if (mission_id === "new" || !mission_id) return
    const data = await fetch_missions_by_id(mission_id)
    if (data?.status === 200) {
      setMissionsData(data.data?.mission_data)
      if (Object.keys(data.data?.prayer_list_data).length > 0) {
        setPrayerListData(data.data?.prayer_list_data)
      }
      setPrayers(data.data?.prayer)
    }
  }



  const fetchCountries = async () => {
    const data = await fetch_all_countries();
    if (data.status === 200) {
      setCountryData(data.data)
    }
  }

  useEffect(() => {
    fetchAccounts()
  }, [])

  const fetchAccounts = async () => {
    setLoading(true)
    const { data, error, message, status } = await fetch_all_accounts()
    if (error) return console.log("Error fetching accounts:", message)
    setAccountData(data)
    setLoading(false)
  }


  useEffect(() => {
    if (mission_id !== "new") {
      fetchMissionById()
    }
    fetchCountries()
    fetchMissionary()
    fetchPlatformUsers()
  }, [])


  const createMission = async () => {
    const data = await create_new_mission(missionData)
    if (data?.status === 200) {
      navigate("/admin/missions/details?mission_id=" + data.data.id)
      fetchMissionById()
      notify({ type: "success", message: "Mission created successfully" })
    } else {
      notify({ type: "error", message: data?.message })
    }
  }

  const updateMission = async () => {
    if (mission_id === "new") {
      // Create new mission
      const data = await create_new_mission(missionData)
      if (data?.status === 200) {
        navigate("/admin/missions/details?mission_id=" + data.data.id)
        fetchMissionById()
        notify({ type: "success", message: "Mission created successfully" })
        savePrayerList()
      } else {
        notify({ type: "error", message: data?.message })
      }
    } else {
      // Update existing mission
      const data = await update_mission(mission_id, missionData)
      if (data?.status === 200) {
        notify({ type: "success", message: "Mission updated successfully" })
        fetchMissionById()
        updatePrayerList()
      } else {
        notify({ type: "error", message: data?.message })
      }
    }
  }

  const deleteMission = async () => {
    if (mission_id === "new" || !mission_id) return
    const data = await delete_mission(mission_id)
    if (data?.status === 200) {
      notify({ type: "success", message: "Mission deleted successfully" })
      navigate(-1)
    } else {
      notify({ type: "error", message: data?.message })
    }
  }

  const fetchMissionary = async () => {
    if (!mission_id || mission_id === "new") return
    const data = await fetch_mission_members_by_id(mission_id)
    if (data?.status === 200) {
      setMissionaryData(data.data)
    } else {
      notify({ message: data?.message, type: "error" })
    }
  }

  const addMember = async (member_id, role) => {
    const data = await add_mission_member({
      mission_id: mission_id,
      user_id: member_id,
      role: role
    })
    if (data?.status === 200) {
      fetchMissionary()
      notify({ message: data?.message, type: "success" })
    } else {
      notify({ message: data?.message, type: "error" })
    }
  }

  const removeMember = async (member_id) => {
    if (!mission_id || mission_id === "new") return
    const data = await remove_mission_member(mission_id)
    if (data?.status === 200) {
      fetchMissionary()
      notify({ message: data?.message, type: "success" })
    } else {
      notify({ message: data?.message, type: "error" })
    }
  }

  const updateMember = async (member_id, role) => {
    if (!mission_id || mission_id === "new") return
    const data = await update_mission_member(mission_id, {
      user_id: member_id,
      mission_id: mission_id,
      role: role
    })
    if (data?.status === 200) {
      fetchMissionary()
      notify({ message: data?.message, type: "success" })
    } else {
      notify({ message: data?.message, type: "error" })
    }
  }


  const fetchPlatformUsers = async () => {
    setLoading(true)
    const data = await fetch_all_users_admin()
    if (data?.status === 200) {
      setUsers(data.data)
      console.log(data.data)
    }
    setLoading(false)
  }

  const savePrayerList = async () => {
    setLoading(true)
    let endpoint = config.endpoint + "/prayer/list"
    let response = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({
        ...prayerListData,
        prayers,
        mission_id
      })
    })
    let data = await response.json()
    if (data.status === 200) {
      // setPrayerListData(data.data)
      fetchMissionById()
      // navigate("/admin/prayer/details?prayer_list_id=" + data.data.id)
      notify({ type: "success", message: "Saved prayer list" })
    } else {
      notify({ type: "error", message: "Failed to save prayer list" })
    }
    setLoading(false)
  }

  const updatePrayerList = async () => {
    if (!prayerListData?.id) return
    setLoading(true)
    let endpoint = config.endpoint + "/prayer/list/id/" + prayer_list_id
    let response = await fetch(endpoint, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({
        ...prayerListData,
        prayers
      })
    })
    let data = await response.json()
    if (data.status === 200) {
      fetchMissionById()
      notify({ type: "success", message: "Updated prayer list" })
    } else {
      notify({ type: "error", message: "Failed to update prayer list" })
    }
    setLoading(false)
  }

  const ROLES = [
    { value: 0, label: "Missionary" },
    { value: 1, label: "Treasurer" },
    { value: 2, label: "Leader" },
  ]

  return (
    <AdminLayout
      navSelected={"Missions"}
      regularContainer={mission_id != "new"}
      toolbar={
        <>
          <h1 className='text-lg font-semibold text-gray-900'>Mission Details</h1>
          <div className='flex gap-2'>
            {mission_id !== "new" && (
              <button
                className="inline-flex items-center px-4 py-2 bg-red-600 hover:bg-red-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200"
                onClick={() => {
                  deleteMission()
                }}
              >
                Delete
              </button>
            )}
            <button
              className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200"
              onClick={updateMission}
            >
              {mission_id === "new" ? "Create" : "Update"}
            </button>
          </div>
        </>
      }
    >
      {/* Adding User Modal */}
      <ModalLayout isVisible={showMemberModal} setIsVisible={setShowMemberModal} modalTitle="Add User to mission">
        <div className="input-container">
          <label htmlFor="" className="input-label">User</label>
          <Select
            options={users.map(user => ({ label: user.first_name + " " + user.last_name, value: user.id }))}
            onChange={(e) => {
              setTempUserData(e)
            }}
          />
        </div>
        <div className="input-container">
          <label htmlFor="" className="input-label">Role</label>
          <Select
            options={ROLES}
            onChange={(e) => {
              setTempUserData({ ...tempUserData, role: e.value })
            }}
          />
        </div>
        <div className="flex-row flex gap-2 alignEnd">
          <button className="button"
            onClick={() => {
              addMember(tempUserData.value, tempUserData.role)
              setShowMemberModal(false)
            }}
          >Add</button>
        </div>
      </ModalLayout>
      {/* <pre>{JSON.stringify(countryData,null,2)}</pre> */}
      {/* <pre>{JSON.stringify(prayers,null,2)}</pre> */}
      {/* <pre>{JSON.stringify(prayerListData, null, 2)}</pre> */}
      <div className="flex-row flex gap-2 alignStart">
        <div className="w-100">
          <div className="card">
            <p className="card-title">Details</p>
            <div className="flex-row flex gap-2 alignStart">
              <div className="input-container">
                <label htmlFor="" className="input-label">Name</label>
                <input
                  type="text"
                  className="text-input"
                  value={missionData?.title}
                  onChange={(e) => {
                    setMissionsData({ ...missionData, title: e.target.value })
                  }}
                  placeholder='e.g. Seekers Baray Mission Trip'
                />
              </div>
              <div className="input-container">
                <label htmlFor="" className="input-label">Country</label>
                <Select
                  options={countryData.map((country) => {
                    return {
                      value: country?.altSpellings?.[0],
                      label: country.name
                    }
                  })}
                  value={countryData.map((country) => {
                    return {
                      value: country?.altSpellings?.[0],
                      label: country.name
                    }
                  }).find((country) => country.value == missionData?.country_id)}
                  onChange={(e) => {
                    setMissionsData({ ...missionData, country_id: e.value })
                  }}
                />
              </div>
            </div>
            <div className="flex-row flex gap-2 items-center">
              <div className="input-container">
                <label htmlFor="" className="input-label">From</label>
                <input
                  type="date"
                  className="text-input"
                  value={missionData?.start_datetime?.split("T")[0]}
                  onChange={(e) => {
                    setMissionsData({ ...missionData, start_datetime: e.target.value })
                  }}
                />
              </div>
              <div className="input-container">
                <label htmlFor="" className="input-label">To</label>
                <input
                  type="date"
                  className="text-input"
                  value={missionData?.end_datetime?.split("T")[0]}
                  onChange={(e) => {
                    setMissionsData({ ...missionData, end_datetime: e.target.value })
                  }}
                />
              </div>
            </div>
            <div className="input-container">
              <label htmlFor="" className="input-label">Description</label>
              {/* <JoditEditor
                ref={editor}
                value={missionData?.description}
                config={liveConfig}
                tabIndex={1} // tabIndex of textarea
                onBlur={newContent => {
                  setMissionsData({ ...missionData, description: newContent })
                }}
              /> */}

              <textarea
                className="textarea-input"
                value={missionData?.description}
                onChange={(e) => {
                  setMissionsData({ ...missionData, description: e.target.value })
                }}
              />
            </div>
          </div>
          {mission_id !== "new" && (
            <div className="mt-10 card">
              <div className="flex-row flex justify-between items-center">
                <p className="card-title">Prayers</p>
                <button className="flex-row flex gap-2 items-center backgroundLess"
                  onClick={() => setPrayers([...prayers, { content: "", is_archived: "0", is_answered: "0", user_id: "", prayer_list_id: "", can_repeat: "0", prayers_count: [], testimony: "" }])}
                >
                  <MdAdd size={20} />
                  <p>Add Prayer</p>
                </button>
              </div>
              {!prayerListData?.id && (
                <div className='column center items-center mt-10'>
                  <p>No Prayer List created for the mission</p>
                  <button className="button"
                    onClick={() => {
                      savePrayerList()
                    }}
                  >Create list</button>
                </div>
              )}
              {prayers.length > 0 && prayers.map((prayer, index) => {
                return (
                  <div key={index} style={{ borderBottom: index != prayer?.length - 1 && "2px solid #f0f0f0", padding: 10 }}>
                    <div className="flex-row items-center flex justify-between">
                      <p className='card-title'>Prayer #{index + 1}</p>
                      <div className="flex-row flex gap-2 items-center">
                        <div className="flex-row flex gap-2 items-center">
                          <FaPrayingHands size={20} color='gray' />
                          <p className='gray'>{prayer.prayers_count?.length}</p>
                        </div>
                        <button className="backgroundLess gap-2 items-center row button-delete"
                          onClick={() => {
                            let newPrayers = [...prayers]
                            newPrayers.splice(index, 1)
                            setPrayers(newPrayers)
                          }}
                        >
                          <MdDelete size={20} />
                          <p>Delete</p>
                        </button>
                      </div>
                    </div>
                    <div className="flex-row flex gap-2 alignStart mt-4">
                      <div className="input-container">
                        <label htmlFor="" className="input-label">Content</label>
                        <textarea className="textarea-input" value={prayer.content} onChange={(e) => {
                          let newPrayers = [...prayers]
                          newPrayers[index].content = e.target.value
                          setPrayers(newPrayers)
                        }} />
                      </div>
                      <div className="flex-row flex gap-2 items-center">
                        <div className="input-container">
                          <label htmlFor="" className="input-label">Answered</label>
                          <Switch
                            checked={prayer.is_answered == "1"}
                            onChange={(checked) => {
                              let newPrayers = [...prayers]
                              newPrayers[index].is_answered = checked ? "1" : "0"
                              setPrayers(newPrayers)
                            }}
                          />
                        </div>
                        <div className="input-container">
                          <label htmlFor="" className="input-label">Repeatable</label>
                          <Switch
                            checked={prayer.can_repeat == "1"}
                            onChange={(checked) => {
                              let newPrayers = [...prayers]
                              newPrayers[index].can_repeat = checked ? "1" : "0"
                              setPrayers(newPrayers)
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    {prayer.is_answered == "1" && (
                      <div className="input-container">
                        <label htmlFor="" className="input-label">Testimony</label>
                        <textarea className="textarea-input" value={prayer.testimony} onChange={(e) => {
                          let newPrayers = [...prayers]
                          newPrayers[index].testimony = e.target.value
                          setPrayers(newPrayers)
                        }} />
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
          )}
        </div>
        <div className="w-50">
          <div className="card">
            <p className="card-title">Accounts</p>
            <Select
              options={accountData.map((account) => ({ value: account.id, label: account.name }))}
              value={accountData.map((account) => ({ value: account.id, label: account.name })).find((account) => account.value == missionData?.account_id)}
              onChange={(e) => {
                setMissionsData({ ...missionData, account_id: e.value })
              }}
            />
          </div>
          {mission_id !== "new" && (
            <div className="card mt-2">
              <p className="card-title">Missionaries</p>

              {/* <div style={{ width: "100%", height: 2, backgroundColor: "gray", marginBlock: 10 }} /> */}
              <div className="flex-row flex w-100 items-center justify-between">
                <p className="card-subtitle"></p>
                <button className="backgroundLess row gap-2 items-center"
                  onClick={() => {
                    setShowMemberModal(true)
                  }}
                >
                  <MdPersonAdd size={12} />
                  <p className="small">Missionary</p>
                </button>
              </div>
              {missionaryData?.length > 0 ? missionaryData?.map((member, index) => (
                <div key={index} className="flex-row flex gap-2 items-center justify-between mt-10 cursor-pointer">
                  <p style={{ fontSize: 14 }}
                    onClick={() => {
                      navigate("/admin/users/details?user_id=" + member.user_id)
                    }} className='cursor-pointer'>{member?.user_data?.first_name} {member?.user_data?.last_name}</p>
                  <div className="flex-row flex gap-2 items-center">
                    <Select
                      options={ROLES}
                      value={ROLES.find(role => role.value == member.role)}
                      onChange={(e) => updateMember(member.user_id, e.value)}
                    />
                    <button
                      className="button-delete"
                      onClick={() => {
                        removeMember(member.user_id)
                      }}
                    >Remove</button>
                  </div>
                </div>
              )) :
                <p className="card-subtitle" style={{ fontStyle: "italic", fontWeight: "900" }}>No Missionary Added</p>
              }
            </div>
          )}
        </div>
      </div>
    </AdminLayout>
  )
}
